import { css, html, LitElement } from "lit"
import faq from "../../../public/donnees/FAQ.json"

export default class PageFAQ extends LitElement {
  static properties = {}

  static styles = css`
    :host .conteneur-faq .conteneur-accordeon {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
    }

    :host .conteneur-faq .conteneur-accordeon p-icone {
      display: inline-flex;
      transition: transform 0.2s ease;
      transform: rotate(0deg);
    }

    :host .conteneur-faq .conteneur-accordeon.ouvert p-icone {
      transform: rotate(180deg);
    }

    :host .conteneur-faq .conteneur-accordeon h2 {
      margin: 15px 0;
    }

    :host .conteneur-faq .accordeon {
        padding: 0;
    }

    :host .conteneur-faq p span {
      background-color: var(--couleur-300);
      padding: 10px;
      border-radius: 10px;
      display: block;
      min-height: 0;
      overflow: hidden;
    }

    :host .conteneur-faq {
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: var(--couleur-100);
    }

    :host .conteneur-faq p {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.25s ease;
      padding: 0;
      margin: 0;
    }

    :host .conteneur-faq p.accordeon-ouvert {
      max-height: var(--accordeon-max-height, 0px);
    }

    :host .conteneur-faq p.accordeon-ferme {
      max-height: 0;
    }
    `

  render() {
    return html`
    <main>
      <header>
            <h1>Foire aux questions</h1>
            <p>Voici les réponses aux questions les plus fréquemment posées sur l'application d'échanges de pokémons pour Pokémon Go. Si vous avez d'autres questions, n'hésitez pas à nous contacter.</p>
      </header>
            <section class="conteneur-faq">
        ${faq.map(
          (item) => html`
          <article>
            <div class="conteneur-accordeon" @click="${() => this._activerOuDesactiverAccordeon(item)}">
              <p-icone icone="accordeon"></p-icone><h2 class="accordeon">${item.question}</h2>
            </div>
            <p class="accordeon-ferme"><span>${item.reponse}</span></p>
          </article>
                `,
        )}
              </section>
      </main>
        `
  }

  _activerOuDesactiverAccordeon(item) {
    const index = faq.indexOf(item)
    const article = this.shadowRoot.querySelectorAll("article")[index]
    const conteneurAccordeon = article.querySelector(".conteneur-accordeon")
    const p = article.querySelector("p")
    const contenu = p.querySelector("span")
    p.style.setProperty("--accordeon-max-height", `${contenu.scrollHeight}px`)

    const estFerme = p.classList.contains("accordeon-ferme")
    if (estFerme) {
      p.classList.remove("accordeon-ferme")
      p.classList.add("accordeon-ouvert")
      conteneurAccordeon.classList.add("ouvert")
      return
    }

    p.classList.remove("accordeon-ouvert")
    p.classList.add("accordeon-ferme")
    conteneurAccordeon.classList.remove("ouvert")
  }
}
customElements.define("p-page-faq", PageFAQ)
